import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import { GlobalActions, ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasRsData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasRsDataForShop } from './transformer/rsData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasRsData
>(App.RS);
export const shopTarifierer = new ShopTarifierer({
  appId: App.RS,
  taasDataBuilder: buildTaasRsDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungRS(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_RS,
    safeSaga(shopTarifierer.handleSuccess, App.RS),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(shopTarifierer.callTarifierung, App.RS),
  );
}
